import Header from '../components/Elements/header';
import Footer from '../components/Elements/footer';
import { Route, Routes } from 'react-router-dom';
import DashboardViews from '../views/dashboard';
import SubHeader from '../components/Elements/subHeader';

function DashboardLayout() {
  return (
    <>
      <Header />
        <SubHeader />
        <div className='pt-10'>
          <Routes>
            <Route path="/*" element={<DashboardViews />} />
          </Routes>
        </div>
      <Footer />
    </>
  );
}

export default DashboardLayout;
